(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UnidadeDialogController', UnidadeDialogController);

    UnidadeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Unidade', 'Pessoa', 'Tecnico', 'Sensor', 'Unidadegestor', 'User', 'Pessoapropriedade'];

    function UnidadeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Unidade, Pessoa, Tecnico, Sensor, Unidadegestor, User, Pessoapropriedade) {
        var vm = this;

        vm.unidade = entity;
        vm.clear = clear;
        vm.save = save;
        vm.pessoas = Pessoa.query();
        vm.tecnicos = Tecnico.query();
        vm.sensors = Sensor.query();
        vm.unidadegestors = Unidadegestor.query();

        vm.onSaveUser = onSaveUser;
        vm.onSavePessoa = onSavePessoa;
        vm.onSaveSuccess = onSaveSuccess;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.unidade.id !== null) {
                Unidade.update(vm.unidade, vm.onSavePessoa, vm.onSaveError);
            } else {
                Unidade.save(vm.unidade, vm.onSaveSuccess, vm.onSaveError);
            }
        }

        function onSaveSuccess(result) {
            vm.unidade.id = result.id;
            $scope.$emit('netWordAgroApp:unidadeUpdate', result);
            vm.novousuario = new User();
            vm.novousuario.login = vm.unidade.login;
            vm.novousuario.firstName = vm.unidade.nome;
            vm.novousuario.lastName = vm.unidade.nome;
            vm.novousuario.email = vm.unidade.email;
            vm.novousuario.authorities = [];
            vm.novousuario.authorities = ['ROLE_GESTOR_PARCEIROS', 'ROLE_USER'];
            User.save(vm.novousuario, onSaveUser);
        }

        function onSaveUser(result) {
            vm.novapessoa = new Pessoa();
            vm.novapessoa.nome = vm.unidade.nome;
            vm.novapessoa.sobrenome = vm.unidade.nome;
            vm.novapessoa.cpf = vm.unidade.cnpj;
            vm.novapessoa.cargo = "gestorparceiro";
            vm.novapessoa.email = vm.unidade.email;
            vm.novapessoa.login = vm.unidade.login;
            vm.novapessoa.unidade = new Unidade();
            vm.novapessoa.unidade.id = vm.unidade.id;
            Pessoa.save(vm.novapessoa, onSavePessoa, onSaveError);
        }

        function onSavePessoa(result){
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
